<template>
  <div class="inner-wrapper">
    <div class="inner-wrapper-md">
      <div class="row">
        <div class="col-12">
          <h4 class="page-title">
            Link to reset password sent! {{ this.$route.params.id }}
          </h4>

          <p class="body">
            We have just sent an email to
            <span class="label-active">{{ this.Email }}</span>. Follow the
            link in the email to reset you password.
          </p>
          <p class="body">
            If you cannot find the email in your inbox, check in your spam
            folder. If you haven’t received it, you can request it again.
          </p>
          <div class="form-row cta-group flex-column-reverse flex-md-row">
            <router-link role="navigation" class="back-link" :to="{ name: 'signin' }">
              <span class="angle-left-green"></span>
              Back to sign in</router-link
            >
            <button 
              class="cta-white-169"
              
              @click="resendEmail()"
               @keydown.enter="resendEmail()"
            >
              Resend email<span class="angle-right-white"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import router from "../router";
import { mapActions } from "vuex";
//import { publicRouter } from "../router";
import { mapState } from "vuex";

export default {
  name: "PasswordSent",
  // data() {
  //   return {
  //     email: ""
  //   };
  // },
  computed: {
    ...mapState("account", ["status"]),
    Email: {
      get() {
        return this.status.Email;
      } //,
      // set(val) {
      //   this.$store.commit(`account/${RESETPASSWORD}`,{email: val });
      // }
    }
  },
  methods: {
    ...mapActions("account", ["forgotPassword"]),
    async resendEmail() {
      //let reset = 
      await this.forgotPassword({ username: this.Email });
      // if (reset)
      //   publicRouter.push({ name: "password-reset", query: { id: "2" } });
    }
  }
};
</script>

<style lang="scss" scoped></style>
